import type { FaireProductEntity } from "../../entity_types/product";

export const p_mt6tzazqk8: FaireProductEntity = {
  token: "p_mt6tzazqk8",
  type: "product",
  name: "CATSUP - Thank You Card",
  brandToken: "b_2e4a1d49",
  brandName: "Carolyn Suzuki",
  imageUrl:
    "https://cdn.faire.com/fastly/75c04a67d7d067375b00b308b17412626194eb424bce560ea2d65ebd4069825b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e2a6d5f7493c918cfb6d6a9235dfd42461d7b33c5f1e0a974bc7d8943eaf6f3.png",
    "https://cdn.faire.com/fastly/da98791517f4bb376d365721436f38a29edbe5b5edc46a9580b2be9ca5d89f20.png",
  ],
  priceDollars: 3.25,
  description:
    "Thank You Card, blank inside. A2 Size - 4.25 by 5.5 inches\n\nComes with a coordinated envelope and packaged in a clear sleeve\n\nLovingly designed by Carolyn Suzuki in Los Angeles, California.\n\nPrinted on carbon neutral FSC certified paper in the United Kingdom.",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:44.500Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
